import { render, staticRenderFns } from "./MovieUpcoming.vue?vue&type=template&id=628246c1&scoped=true"
import script from "./MovieUpcoming.vue?vue&type=script&lang=js"
export * from "./MovieUpcoming.vue?vue&type=script&lang=js"
import style0 from "./MovieUpcoming.vue?vue&type=style&index=0&id=628246c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628246c1",
  null
  
)

export default component.exports